import { ApiBase } from "@/api/ApiBase";

export interface CaixaResumo {
  id: number;
  codigo: string;
  nome: string;
  estabelecimento_id: number;
  sessao: string;
  nomeEstabelecimento: string;
  numeroEstabelecimento: string;
  vendedor: string;
  grupoVendedor: string | null;
  dataCriacao: string;
}

export interface DadosCaixaForm {
  nome: string;
  estabelecimentoId: number;
}

export interface EditarApagarCaixaResponse {
  msg: string;
  tipo: "sucesso" | "erro";
}

export interface HistoricoSessaoCaixaItem {
  idSessao: number;
  dataAbertura: string;
  dataFecho: string | null;
  valorAbertura: number;
  valorFecho: number;
  estado: "Aberto" | "Fechado";
  nomeVendedor: string;
  nomeEstabelecimento: string;
  numeroEstabelecimento: string;
  nomeCaixa: string;
  totalVendas: number;
}

export class CaixasApi extends ApiBase {
  listar(): Promise<CaixaResumo[]> {
    return this.http.put<CaixaResumo[]>("/api-pos/caixa/lista-by-comerciante");
  }

  adicionar(dados: DadosCaixaForm): Promise<EditarApagarCaixaResponse> {
    return this.http.post<EditarApagarCaixaResponse>("/api-pos/caixa/add", {
      nome: dados.nome,
      "estabelecimento.id": String(dados.estabelecimentoId),
    });
  }

  editar(
    id: number,
    codigo: string,
    dados: DadosCaixaForm,
  ): Promise<EditarApagarCaixaResponse> {
    return this.http.post<EditarApagarCaixaResponse>("/api-pos/caixa/edit", {
      id: String(id),
      codigo,
      nome: dados.nome,
      "estabelecimento.id": String(dados.estabelecimentoId),
    });
  }

  apagar(
    id: number,
    codigo: string,
    estabelecimentoId: number,
  ): Promise<EditarApagarCaixaResponse> {
    return this.http.post<EditarApagarCaixaResponse>("/api-pos/caixa/delete", {
      id: String(id),
      codigo,
      "estabelecimento.id": String(estabelecimentoId),
    });
  }

  listaHistorico(
    codigo: string,
    pagina: number,
  ): Promise<HistoricoSessaoCaixaItem[]> {
    return this.http.put<HistoricoSessaoCaixaItem[]>(
      `/api-pos/caixa/lista-historico-by-caixa/${codigo}/${pagina}`,
    );
  }

  fecharAdmin(idSessao: number): Promise<EditarApagarCaixaResponse> {
    return this.http.post<EditarApagarCaixaResponse>(
      `/api-pos/caixa/fechar-admin/${idSessao}`,
    );
  }
}
